import React from 'react';
import { useNavigate } from 'react-router-dom';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const ReportHeader = ({ reportTitle, projectId, projectName }) => {
  const navigate = useNavigate();

  return (
    <div className="bg-card border-b border-border p-6 mb-6">
      <div className="flex items-start justify-between gap-4">
        <div className="flex-1 min-w-0">
          <div className="flex items-center gap-2 mb-2">
            <Button
              variant="ghost"
              size="icon"
              iconName="ArrowLeft"
              onClick={() => navigate('/project-detail-view')}
              title="Volver al proyecto"
            />
            <div className="flex items-center gap-2 text-sm text-muted-foreground caption">
              <span className="cursor-pointer hover:text-foreground transition-colors" onClick={() => navigate('/main-dashboard')}>
                Dashboard
              </span>
              <Icon name="ChevronRight" size={14} />
              <span className="cursor-pointer hover:text-foreground transition-colors" onClick={() => navigate('/project-detail-view')}>
                {projectName}
              </span>
              <Icon name="ChevronRight" size={14} />
              <span className="text-foreground">Informe</span>
            </div>
          </div>

          <h1 className="text-2xl md:text-3xl lg:text-4xl font-bold text-foreground font-mono mb-2">
            {reportTitle}
          </h1>

          <div className="flex items-center gap-4 text-sm text-muted-foreground caption">
            <div className="flex items-center gap-2">
              <Icon name="FolderTree" size={16} />
              <span>ID: {projectId}</span>
            </div>
            <div className="flex items-center gap-2">
              <Icon name="Calendar" size={16} />
              <span>{new Date()?.toLocaleDateString('es-ES', { day: '2-digit', month: 'long', year: 'numeric' })}</span>
            </div>
          </div>
        </div>

        <div className="hidden md:flex items-center gap-2">
          <Button
            variant="outline"
            iconName="MessageSquare"
            iconPosition="left"
            onClick={() => navigate('/main-dashboard')}
          >
            Consultar Agentes
          </Button>
          <Button
            variant="default"
            iconName="FileText"
            iconPosition="left"
            onClick={() => console.log('Generate new report')}
          >
            Nuevo Informe
          </Button>
        </div>
      </div>
      <div className="md:hidden flex flex-col gap-2 mt-4">
        <Button
          variant="outline"
          fullWidth
          iconName="MessageSquare"
          iconPosition="left"
          onClick={() => navigate('/main-dashboard')}
        >
          Consultar Agentes
        </Button>
        <Button
          variant="default"
          fullWidth
          iconName="FileText"
          iconPosition="left"
          onClick={() => console.log('Generate new report')}
        >
          Nuevo Informe
        </Button>
      </div>
    </div>
  );
};

export default ReportHeader;